define('lq/events/actions/shareOnTwitter',[
    'lq/events/actions/eventAction'
], function (EventAction) {
    'use strict';

    var twitterUrl = 'https://twitter.com/intent/tweet'; 

    function ShareOnTwitter(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
    }

    EventAction.extend(ShareOnTwitter, EventAction);

    ShareOnTwitter.typeName = 'ShareOnTwitter';

    ShareOnTwitter.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    ShareOnTwitter.prototype.execute = function (continuation, eventActionResponse) {
        var url = twitterUrl;
        var parameters = this.getParameters();

        if (_.keys(parameters).length)
            url = url + '?' + $.param(parameters);

        window.open(url, '', 'left=0,top=0,width=550,height=450,personalbar=0,toolbar=0,scrollbars=0,resizable=0');

        continuation();
    };

    ShareOnTwitter.prototype.getParameters = function () {
        var parameters = {};

        if (this.eventData.twitter.text)
            parameters['text'] = this.piping.parameters.replace(this.eventData.twitter.text);

        if (this.eventData.twitter.url)
            parameters['url'] = this.piping.parameters.replace(this.eventData.twitter.url);

        if (this.eventData.twitter.hashtags)
            parameters['hashtags'] = this.piping.parameters.replace(this.eventData.twitter.hashtags);

        if (this.eventData.twitter.via)
            parameters['via'] = this.piping.parameters.replace(this.eventData.twitter.via);

        return parameters;
    };

    return ShareOnTwitter;
});
